import { Account } from '@/domain/usecases'
import { trackEvent } from '@/infra/tracking/analytics'
import { settings } from '@/main/config/settings'
import { safeTrackCall } from '@/presentation/pages/common-analytics'

export namespace Analytics {
  export const trackAccountIdentification = safeTrackCall(
    async (data: Account.Model | undefined) => {
      if (!data) return
      trackEvent('user_identify', {
        user_id: data.id,
        user_account_type: data.accountType?.name,
        user_email: data.email,
        user_name: data.name,
        user_picture_url: data.pictureUrl,
        user_language: data.preferenceLanguage,
        user_onboarding_completed: data.onboardingCompleted,
        user_onboarding_completed_at: data.onboardingCompletedAt
          ? data.onboardingCompletedAt.toISOString()
          : null,
        user_pass_plan_id: data.passPlan?.id,
        user_addons_refund_enabled: data.addons?.refund.enabled,
        user_roles: data.roles?.map(role => role.name),
        user_company_id: data.company.uniqueId,
        user_company_name: data.company.name,
        user_environment: settings.APP_ENV
      })
    }
  )
}
